<div class="zones-container">
    <app-zone-overview class="zone"
                        *ngFor="let zone of zones"
                        [zone]="zone"
                        [showArrow]="true"
                        [showEdit]="true"
                        (onZoneUpdate)="updateZones()"></app-zone-overview>

</div>

